export default __webpack_public_path__ + "static/media/elijah.65b1e716.png";